<template>
  <span>
    <template v-if="id">
      <template v-if="companyName">
        <span class="f-500">{{ companyName }}</span>
        <br />
      </template>
      <a :href="`/job/${id}`">
        {{ truncateText(name) }}
      </a>
      <div>
        <WdsLabel v-if="isCompleted" subtle sm error>{{ $t('Job ended') }}</WdsLabel>
      </div>
    </template>
    <em v-else>
      {{ $t("The job doesn't exist") }}
    </em>
  </span>
</template>

<script>
import { WdsLabel } from '@worksome/wds-components'
import { textHelpers } from '@/utils/tools'

export default {
  components: { WdsLabel },
  props: {
    globalId: {
      type: String,
      default: 0,
    },
    localId: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    isCompleted: {
      type: Boolean,
      default: false,
    },
    companyName: {
      type: String,
      default: '',
    },
  },
  computed: {
    id() {
      return this.localId || this.globalId
    },
  },
  methods: {
    truncateText: textHelpers.truncate,
  },
}
</script>

<style scoped></style>
